interface TemplateSuggestion {
  id: string;
  label: string;
  prompt: string;
}

const TEMPLATE_SUGGESTIONS: TemplateSuggestion[] = [
  {
    id: 'grwm-makeup',
    label: 'Creators filming GRWM makeup videos in natural light',
    prompt: 'Creators filming GRWM makeup videos in natural light',
  },
  {
    id: 'beauty-minimalist',
    label: 'Beauty influencers with minimalist aesthetic',
    prompt: 'Beauty influencers with minimalist aesthetic',
  },
  {
    id: 'fashion-indoor',
    label: 'Fashion creators shooting outfit videos indoors',
    prompt: 'Fashion creators shooting outfit videos indoors',
  },
  {
    id: 'home-workout',
    label: 'Home workout creators with bright, clean backgrounds',
    prompt: 'Home workout creators with bright, clean backgrounds',
  },
];

interface Props {
  onSelect: (prompt: string, source?: 'free_text' | 'template') => void;
}

export function DiscoveryTemplateSuggestions({ onSelect }: Props) {
  return (
    <div className="flex flex-wrap justify-center gap-3">
      {TEMPLATE_SUGGESTIONS.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.prompt, 'template')}
          className="rounded-full border border-input bg-background px-4 py-2 text-sm text-foreground transition-colors hover:bg-muted"
        >
          {suggestion.label}
        </button>
      ))}
    </div>
  );
}
